var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2.34961,
    width: 3,
    height: 0.85,
    transform: "rotate(-180 11 2.34961)",
    fill: "#0031DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1.5,
    width: 3,
    height: 0.85,
    transform: "rotate(90 11 1.5)",
    fill: "#0031DB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2.10059,
    width: 4.5,
    height: 0.85,
    transform: "rotate(135 11 2.10059)",
    fill: "#0031DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.34961,
    width: 4.5,
    height: 0.85,
    transform: "rotate(-180 5.5 2.34961)",
    fill: "#0031DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11.5,
    width: 10,
    height: 0.999999,
    transform: "rotate(-180 11 11.5)",
    fill: "#0031DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11.5,
    width: 10,
    height: 1,
    transform: "rotate(-90 1 11.5)",
    fill: "#0031DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.5,
    width: 5,
    height: 1,
    transform: "rotate(-90 10 11.5)",
    fill: "#0031DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalIcon);
export default __webpack_public_path__ + "static/media/external_icon.9979e5c3195503f51499fddb80938d0d.svg";
export { ForwardRef as ReactComponent };